import { reduce, split, replace } from 'lodash';

export const lodashQueryString = (search: string): { [key: string]: string[] } => {
  return reduce(split(replace(search, '?', ''), '&'), function(result: { [key: string]: string[] }, ev) {
    (result[ev.split('=')[0]] || (result[ev.split('=')[0]] = [])).push(ev.split('=')[1]);
    return result;
  }, {});
};
